import {
    DIC
} from '@/const/dic'
import {
    validateCapitalUnderline,
    validateChinese
} from '@/util/validate'


export const balanceDetailsOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
        label: "创建时间",
        prop: "createTime",
        type: "datetime",
        sortable: true,
        format: "yyyy-MM-dd HH:mm:ss",
        addVisdiplay: false,
        editVisdiplay: false
    },

        {
            label: "姓名",
            prop: "createBy",
            type: "input"
        },
        {
            label: "入账金额",
            prop: "amount",
            type: "input"
        }

    ]
};